import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadPoss: false,
  isLoadRestau6: false,
  errorRestau6: "",
  poss: [],
  possSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadPoss: state => state.isLoadPoss,
  isLoadRestau6: state => state.isLoadRestau6,
  errorRestau6: state => state.errorRestau6,
  poss: state => state.poss,
};

const mutations = {
  getPossSuccess(state, payload) {
    state.isLoadPoss = true;
    state.poss = payload.poss;
  },
  addPosSuccess(state, payload) {
    state.isLoadPoss = true;
    let poss = state.poss;
    poss.push(payload.data);
    state.poss = poss;
  },
  editPosSuccess(state, payload) {
    // console.log("FRRROOOM MUTATE ");
    state.isLoadPoss = true;
    let poss = state.poss;

    let newPoss = [];
    poss.map((pos, index) => {
      if (pos._id == payload.data._id) {
        newPoss.push({ ...payload.data });
      } else {
        newPoss.push({ ...pos });
      }
    });
    console.log(state.poss);
    state.poss = [...newPoss];
  },
  deletePosSuccess(state, payload) {
    state.isLoadPoss = true;
    let poss = state.poss;

    let newPoss = [];
    poss.map((pos, index) => {
      if (pos._id != payload.data._id) {
        newPoss.push({ ...pos });
      }
    });
    state.poss = [...newPoss];
  },
  addPOSSuccess(state, payload) {
    state.isLoadPoss = true;

  },
  getPossError(state, error) {
    state.isLoadPoss = false;
    state.errorRestau6 = error;
  },
  addPosError(state, error) {
    state.isLoadPoss = false;
    state.errorRestau6 = error;
  }
};

const actions = {
  getCenters({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios.post(`${apiPath}/centers`, payload, config).then(r => r.data);
  },
  getCentersRes({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/getCenters/${8}`, payload, config)
      .then(r => r.data);
  },
  getCustomCenters({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/getCustomCenters/${8}`, payload, config)
      .then(r => r.data);
  },
  getPoss({ commit }, payload) {
    
    axios
      .get(`${apiPath}/pos?restaurant=${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getPossSuccess", {
            poss: res.data
          });
        } else {
          commit("getPossError", "error:getPoss");
        }
      });
  },
  addPos({ commit }, payload) {
    return axios
      .post(`${apiPath}/pos`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addPosSuccess", res);
        } else {
          alert(res.message);
          location.replace("/");
          commit("addPosError", "error:addPos");
        }
        return res;
      });
  },
  editPos({ commit }, payload) {
    return axios
      .post(`${apiPath}/pos/${payload._id}`, payload, config)
      .then(r => r)
      .catch(r => r);
    // .then(res => {
    //   if (res.ok) {
    //     commit("editPosSuccess", res);
    //   } else {
    //     commit("addPosError", "error:addPos");
    //   }
    //   return res;
    // });
  },
  // SyncRestau({ commit }, payload,config) {
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  // },

  deletePos({ commit }, payload) {
    return axios
      .delete(`${apiPath}/pos/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePosSuccess", payload);
        // } else {
        //   commit("addPosError", "error:addPos");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addPOSSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
